import { Flex } from "@components/index";
import React from "react";
import { TimeRangeStatus } from "../components/internal/TimeRangeStatus";
import { useChannelIcons } from "../hooks";

interface TimesGanttFragmentType {
  event: Sentinel.Timeline.Event;
  gapRow: string;
}

const TimesGanttFragment: React.FC<
  React.HTMLAttributes<HTMLDivElement> & TimesGanttFragmentType
> = ({ event, gapRow, ...props }) => {
  const { getChannelIcons } = useChannelIcons(event);

  const displayProps = event.displayProps ?? {
    displayStartDate: null,
    displayEndDate: null,
    showLateIcon: false,
    markStartBackground: false,
    markEndBackground: false,
  };

  return (
    <Flex.Row gap={gapRow} alignItems="center" {...props}>
      {getChannelIcons()}
      <span>|</span>

      <TimeRangeStatus
        isStartLate={displayProps.markStartBackground}
        isEndLate={displayProps.markEndBackground}
        startDate={displayProps.displayStartDate ?? ""}
        endDate={displayProps.displayEndDate ?? ""}
      />
    </Flex.Row>
  );
};

export default TimesGanttFragment;
